import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Mainpage from "./pages";
import DocumentGenerator from "./pages/DocumentGenerator/DocumentGenerator";
import { useAuth0 } from "@auth0/auth0-react";
import { Container, CircularProgress } from "@mui/material";
import useIsDemoInstance from "./pages/Chat/Chat-Hooks/useIsDemoInstance";

function App() {
  const { isLoading, error, isAuthenticated, loginWithRedirect } = useAuth0();
  const isDemoInstance = useIsDemoInstance();

  useEffect(() => {
    // Redirect to login if the user is not authenticated and not currently loading
    if (!isLoading && !isAuthenticated) {
      loginWithRedirect({
        appState: { returnTo: window.location.pathname },
      });
    }
  }, [isLoading, isAuthenticated, loginWithRedirect]);

  if (isLoading) {
    return (
      <Container
        component="main"
        maxWidth="xs"
        sx={{ textAlign: "center", mt: 8 }}
      >
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return <div>Oops... {error.message}</div>;
  }

  return (
    <Router>
      <Routes>
        {/* Standalone full-screen document generator — demo instances only */}
        {isDemoInstance && (
          <Route path="/document-generator" element={<DocumentGenerator />} />
        )}
        <Route path="/*" element={<Mainpage />} />
      </Routes>
    </Router>
  );
}

export default App;
